import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { addAdmin, removeAdmin, getExistingAdmins } from "../components/Requests/Requests";
import {
  StandardScreen,
  StandardTextField, 
  StandardDropdown, 
  StandardButton, 
  StatusMessage,
  PageLayout,
} from '../components/Layout';

class Admins extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            message: "",
            error: "",
            email: "",
            existingAdminChosen: "",
            onSelectAdmin: "",
            removeAdminError: "",
            removeAdminMessage: "",
            existingAdmins: "",

        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.getExistingAdmins();
    }

    onSelectAdmin = (event, item) => {
        this.setState({ existingAdminChosen: item.key });
    };

    onEmailChange = (event, newValue) => {
        this.setState({ 
            email: newValue,
            message: "",
            error: ""
        });
    };

    onAdminDropdownChange = (event, item) => {
        this.setState({ 
            existingAdminChosen: item.key,
            removeAdminError: "",
            removeAdminMessage: ""
        });
    };

    async getExistingAdmins() {
        this.setState({ loading: true })
        let response = await getExistingAdmins(this.props.accessToken);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                loading: false,
                existingAdmins: data.map(item =>
                    ({ key: item, text: item })),
            });
        } else {
            this.setState({ loading: false, removeAdminError: "Something went wrong", removeAdminMessage: "" });
        };
    }

    async addAdmin() {
        this.setState({ loading: true })
        let requestBody = {};
        requestBody = {
            Email: this.state.email,
        };
        let response = await addAdmin(this.props.accessToken, requestBody);
        let data = await response.json();
        if (response.status === 200) {
            this.setState({ loading: false, message: data.message })
        } else if (response.status === 401) {
            this.setState({ loading: false, error: data.message, message: "" });
        } else {
            this.setState({ loading: false, error: "Something went wrong" });
        };
    }

    async removeAdmin() {
        this.setState({ loading: true })
        let requestBody = {};
        requestBody = {
            Email: this.state.existingAdminChosen,
        };
        let response = await removeAdmin(this.props.accessToken, requestBody);
        let data = await response.json();
        if (response.status === 200) {
            this.setState({ loading: false, removeAdminMessage: data.message })
        } else if (response.status === 401) {
            this.setState({ loading: false, removeAdminError: data.message, removeAdminMessage: "" });
        } else {
            this.setState({ loading: false, removeAdminError: "Something went wrong" });
        };
    }

    render() {
        const {
            loading,
            message,
            error,
            email,
            existingAdminChosen,
            removeAdminError,
            removeAdminMessage,
            existingAdmins
        } = this.state;

        return (
            <PageLayout>
                <StandardScreen
                    title="Add an Admin to the Management Portal"
                    description="Enter the email address of the user you wish to make an admin."
                    loading={loading}
                >

                    <StandardTextField
                        label="Email"
                        placeholder="Email of new Admin"
                        value={email}
                        onChange={this.onEmailChange}
                    />

                    <StandardButton
                        text="Add"
                        onClick={() => this.addAdmin()}
                        disabled={!email}
                    />

                    {error && (
                        <StatusMessage type="error">{error}</StatusMessage>
                    )}

                    {message && (
                        <StatusMessage type="success">{message}</StatusMessage>
                    )}
                </StandardScreen>
                
                <StandardScreen
                    title = "Remove an Admin from the Management Portal"
                    description = "Select an existing admin to remove their admin permissions."
                    loading={loading}
                >
                    <StandardDropdown
                        label="Admin"
                        selectedKey={existingAdminChosen}
                        onChange={this.onAdminDropdownChange}
                        placeholder="Existing Admins"
                        options={existingAdmins}
                    />

                    <StandardButton
                        text="Delete"
                        onClick={() => this.removeAdmin()}
                        disabled={!existingAdminChosen}
                    />
                    
                    {removeAdminError && (
                        <StatusMessage type="error">{removeAdminError}</StatusMessage>
                    )}

                    {removeAdminMessage && (
                        <StatusMessage type="success">{removeAdminMessage}</StatusMessage>
                    )}
                </StandardScreen>
            </PageLayout>
        );
    }
}

export default Admins;